// Isolated so Jest never has to parse `import.meta` in the main hook. During
// tests, moduleNameMapper redirects this to the sibling mock that returns null.
export function createCsvWorker(): Worker {
    return new Worker(new URL('../workers/csvAnalyzer.worker.ts', import.meta.url), { type: 'module' })
}
